import { Container } from "../../elements/Container";
import { IItemProps, Item } from "./components/Item/Item";
import { styles } from "./UniqueSellingPointsSmall.style";

export interface IUniqueSellingPointsSmallProps {
  title: string;
  items: IItemProps[];
}

export function UniqueSellingPointsSmall({ title, items }: IUniqueSellingPointsSmallProps) {
  return (
    <Container>
      <div className={styles.root()}>
        <h2>{title}</h2>
        <div className={styles.itemsContainer()}>
          {items.map((item) => (
            <Item key={item.label} image={item.image} label={item.label}></Item>
          ))}
        </div>
      </div>
    </Container>
  );
}
